import { makeAutoObservable } from "mobx";
import { SearchSalaryPeriod } from "app/common/Model/SearchObject";
import { deleteSalaryPeriod, getSalaryPeriodById, searchByPageSalaryPeriod, saveOrUpdateSalaryPeriod, saveSalaryPeriodSyncSalaryPeriodHRM } from "app/services/ServiceSalaryPeriod";
import { toast } from "react-toastify";
import { SalaryPeriodType } from "app/common/Model/SalaryPeriod";
//import { downloadSalaryPeriod, importExcelSalaryPeriod } from "app/services/ImportExcelService";
//import moment from "moment";

export default class SalaryPeriodStore {
    openSalaryPeriodCreateOrUpdate = false;
    searchSalaryPeriod = new SearchSalaryPeriod();
    pageSalaryPeriod = null;
    selectedSalaryPeriod = new SalaryPeriodType();
    openConfirmDeleteSalaryPeriod = false;
    openSyncSalaryPeriodHRM = false;

    constructor() {
        makeAutoObservable(this);
    }

    pagingSalaryPeriod = async () => {
        //console.log("Dữ liệu gửi đi:", this.searchSalaryPeriod);
        return await searchByPageSalaryPeriod(this.searchSalaryPeriod)
            .then(({ data }) => {
                //console.log("Dữ liệu gửi đi:", data);
                this.pageSalaryPeriod = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu kỳ lương có lỗi");
            });
    };

    handleOpenFormCreateOrEdit = (salaryPeriodId) => {
        if (salaryPeriodId) {
            getSalaryPeriodById(salaryPeriodId)
                .then(({ data }) => {
                    this.selectedSalaryPeriod = data;
                    this.openSalaryPeriodCreateOrUpdate = true;
                })
                .catch((error) => {
                    toast.error("Lấy dữ liệu kỳ lương có lỗi");
                    console.error("Lỗi lấy dữ liệu kỳ lương:", error);
                });
        } else {
            this.selectedSalaryPeriod = new SalaryPeriodType();
            this.openSalaryPeriodCreateOrUpdate = true;
        }
    };

    handleCreateOrEdit = async (salaryPeriodData) => {
        try {
            //console.log("Dữ liệu gửi đi:", salaryPeriodData);
            const { data } = await saveOrUpdateSalaryPeriod(salaryPeriodData);
            toast.success("Lưu SalaryPeriod thành công!");
            this.handleClosePopup();
            await this.pagingSalaryPeriod();
            return data;
        } catch (error) {
            toast.error("Lưu kỳ lương thất bại!");
            console.error("Lưu kỳ lương thất bại!:", error);
        }
    };

    handleDelete = async () => {
        const salaryPeriodId = this.selectedSalaryPeriod?.id;
        if (!salaryPeriodId) return;

        deleteSalaryPeriod(salaryPeriodId)
            .then(() => {
                // Nếu đang ở trang > 1 và chỉ còn 1 dòng dữ liệu, thì lùi về trang trước
                if (
                    this.searchSalaryPeriod?.pageIndex > 1 &&
                    this.pageSalaryPeriod?.content?.length === 1
                ) {
                    this.searchSalaryPeriod.pageIndex -= 1;
                }
                toast.success("Xóa kỳ lương thành công!");
                this.pagingSalaryPeriod();
                this.handleClosePopup();
            })
            .catch((error) => {
                console.error("Lỗi khi xóa kỳ lương:", error);
                toast.error("Xóa kỳ lương thất bại!");
            });
    };

    handleChangeFormSearch = (searchSalaryPeriod) => {
        this.searchSalaryPeriod = {
            ...this.searchSalaryPeriod,
            ...searchSalaryPeriod,
        };
        this.pagingSalaryPeriod();
    };

    handleDeleteSalaryPeriod = (salaryPeriod) => {
        this.selectedSalaryPeriod = salaryPeriod;
        this.openConfirmDeleteSalaryPeriod = true;
    };

    handleClosePopup = () => {
        this.openSalaryPeriodCreateOrUpdate = false;
        this.openConfirmDeleteSalaryPeriod = false;
    };

    handleOpenSyncSalaryPeriodHRM = () => {
        this.openSyncSalaryPeriodHRM = true
    }

    handleCloseSyncSalaryPeriodHRM = () => {
        this.openSyncSalaryPeriodHRM = false
    }

    handleSaveSyncSalaryPeriodHRM = (data, { setSubmitting }) => {
        saveSalaryPeriodSyncSalaryPeriodHRM(data).then(() => {
            this.openSyncSalaryPeriodHRM = false;
            toast.success("Đồng bộ kỳ lương thành công")
            this.pagingSalaryPeriod();
        }).catch((err) => {
            toast.error("Đồng bộ kỳ lương thất bại")
        }).finally(() => {
            setSubmitting(false)
        })
    }

    resetStore = () => {
        this.searchSalaryPeriod = new SearchSalaryPeriod();
        this.pageSalaryPeriod = null;
        this.selectedSalaryPeriod = new SalaryPeriodType();
        this.openSalaryPeriodCreateOrUpdate = false;
    };
}
